// selected_listings_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["listing", "program"];

  connect() {
    console.log('connecting')
    this.updateSelectedListingsField();
    this.updateSelectedProgramsField();
  }

  toggleListing() {
    this.updateSelectedListingsField();
  }

  toggleProgram() {
    this.updateSelectedProgramsField();
  }

  updateSelectedListingsField() {
    const selectedValues = this.listingTargets
      .filter(listing => listing.checked)
      .map(listing => listing.value)
      .join(",");

    this.element.querySelector('[name=selected_listings]').value = selectedValues;
  }

  updateSelectedProgramsField() {
    const selectedValues = this.programTargets
      .filter(program => program.checked)
      .map(program => program.value)
      .join(",");

    this.element.querySelector('[name=selected_programs]').value = selectedValues;
  }
}
